export function resolveTargetProduct(targetTitle) {
  if (!targetTitle) {
    return null;
  }

  const lastHyphenIndex = targetTitle.lastIndexOf("-");
  const target = targetTitle.substr(lastHyphenIndex + 1).trim();

  return target;
}
